const AlertActionTypes = {
	SHOW_ALERT: "SHOW_ALERT",
	HIDE_ALERT: "HIDE_ALERT",
};

export default AlertActionTypes;
